import { SerperInput } from './types/_Address'

const serperKeys = {
  host: 'https://google.serper.dev/search',
  key: '4597d700634fd111c84687b9570691068b2698ee',
  type: 'application/json',
}

export async function getPlaces(body: SerperInput): Promise<any> {
  const requestOptions = {
    method: 'POST',
    headers: {
      'X-API-KEY': serperKeys.key,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  }
  let res: any = null

  await fetch(serperKeys.host, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}
